<template>
  
  <form class="tool-panel">

      <div class="tool-panel__block">
        <h2><Icon :icon="setFormIcon()"></Icon>{{ setFormTitle }}</h2>
        
        <div v-if="setSavingsFutureData()" :class="getToolClass('savingsFuture')">                             
          <div v-if="isCurrentTool('savingsFuture')" class="tool__output">
            <div class="tool__output-line">
              <span class="tool__output-label"><span v-html="getSavingsFutureFrequencyLabel()"></span></span>
              <span class="tool__output-value" v-html="getSavingsFutureContribution()"></span>
            </div>
            <Chart type="bar" :data="getSavingsFutureData()" id="toolSavingsFutureChart" width="650" height="350"></Chart> 
            <table v-if="showTable('savingsRequired')" class="toolTable">
              <thead>
                <tr class="toolTable__row" >
                  <th class="toolTable__cell">{{ _translate('tool.year') }}</th>
                  <th class="toolTable__cell">{{ _translate('tool.regularDeposits') }}</th>
                  <th class="toolTable__cell">{{ _translate('tool.totalInvested') }}</th>
                  <th class="toolTable__cell">{{ _translate('tool.gain') }}</th>
                  <th class="toolTable__cell">{{ _translate('tool.value') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr class="toolTable__row" v-for="(item, index) in getSavingsFutureTableData()">
                  <td class="toolTable__cell">{{item.year}}</td>
                  <td class="toolTable__cell">{{formatCurrency(item.contribution)}}</td>
                  <td class="toolTable__cell">{{formatCurrency(item.total)}}</td>
                  <td class="toolTable__cell">{{formatCurrency(item.gain)}}</td>
                  <td class="toolTable__cell">{{formatCurrency(item.value)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <form v-if="isCurrentTool('savingsFuture')" class="tool__form">

            <div class="tool__form-wrap">
              <TextInput :label="_translate('tool.sumToAccumulate')" type="currency" field="tools.savingsFuture.sum"></TextInput>
              <TextInput :label="_translate('tool.atRateOf')" type="percentage" field="tools.savingsFuture.rate"></TextInput>
              <TextInput :label="_translate('tool.numberOfYears')" type="number" field="tools.savingsFuture.years"></TextInput>
              <Dropdown :label="_translate('tool.Depositing')" proto="contributionFrequency" field="tools.savingsFuture.depositing"></Dropdown>
              <div class="checkbox-wrap"><input id="showSavingsRequired" type="checkbox" class="checkbox__input" :checked="showTableChecked('savingsRequired')" @change="showTableUpdate('savingsRequired')"> <label for="showSavingsRequired" class="label">{{ _translate('tool.showSummaryTable') }}</label></div>
            </div>

          </form>           
        </div>

        <div v-if="setInvestmentFuture()" :class="getToolClass('investmentFuture')">                              
          <div v-if="isCurrentTool('investmentFuture')" class="tool__output">
            <div class="tool__output-line">
              <span class="tool__output-label">{{ _translate('tool.futureValue') }}</span>
              <span class="tool__output-value" v-html="getInvestmentFutureValue()"></span>
            </div>          
            <Chart type="bar" :data="getInvestmentFutureData()" id="toolInvestmentFutureDataChart" width="650" height="350"></Chart> 
            <table v-if="showTable('futureValue')" class="toolTable">
              <thead>
                <tr class="toolTable__row" >
                  <th class="toolTable__cell">{{ _translate('tool.year') }}</th>
                  <th class="toolTable__cell">{{ _translate('tool.regularDeposits') }}</th>
                  <th class="toolTable__cell">{{ _translate('tool.totalContributions') }}</th>
                  <th class="toolTable__cell">{{ _translate('tool.gain') }}</th>
                  <th class="toolTable__cell">{{ _translate('tool.value') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr class="toolTable__row" v-for="(item, index) in getInvestmentFutureTableData()">
                  <td class="toolTable__cell">{{item.year}}</td>
                  <td class="toolTable__cell">{{formatCurrency(item.contribute)}}</td>
                  <td class="toolTable__cell">{{formatCurrency(item.contribution)}}</td>
                  <td class="toolTable__cell">{{formatCurrency(item.gain)}}</td>
                  <td class="toolTable__cell">{{formatCurrency(item.value)}}</td>
                </tr>
              </tbody>
            </table>            
          </div>
          <form v-if="isCurrentTool('investmentFuture')" class="tool__form">

            <div class="tool__form-wrap">
              <TextInput :label="_translate('tool.initialInvestment')" type="currency" field="tools.investmentFuture.sum"></TextInput>
              <TextInput :label="_translate('tool.growthRate')" type="percentage" field="tools.investmentFuture.rate"></TextInput>
              <TextInput :label="_translate('tool.numberOfYears')" type="number" field="tools.investmentFuture.years"></TextInput>
              <Dropdown :label="_translate('tool.Depositing')" proto="contributionFrequency" field="tools.investmentFuture.depositing"></Dropdown>
              <TextInput :label="_translate('tool.regularDeposits')" type="currency" field="tools.investmentFuture.contribution"></TextInput>
              <div class="checkbox-wrap"><input id="showFutureValue" type="checkbox" class="checkbox__input" :checked="showTableChecked('futureValue')" @change="showTableUpdate('futureValue')"> <label for="showFutureValue" class="label">{{ _translate('tool.showSummaryTable') }}</label></div>
            </div>

          </form>          
        </div>

        <div v-if="setRegularWithdrawals()" :class="getToolClass('regularWithdrawals')">                              
          <div v-if="isCurrentTool('regularWithdrawals')" class="tool__output">
            <div class="tool__output-line">
              <span class="tool__output-label"><span v-html="getRegularWithdrawalsFrequencyLabel()"></span>:</span>
              <span class="tool__output-value" v-html="getRegularWithdrawalsWithdrawal()"></span>
            </div>
            <Chart type="bar" :data="getRegularWithdrawalsData()" id="toolRegularWithdrawalsChart" width="650" height="350"></Chart>
            <p class="note" v-if="showTable('regularWithdrawals')">{{ _translate('tool.withdrawlsFootnote') }}</p>
            <table v-if="showTable('regularWithdrawals')" class="toolTable">
              <thead>
                <tr class="toolTable__row" >
                  <th class="toolTable__cell">{{ _translate('tool.period') }}</th>
                  <th class="toolTable__cell">{{ _translate('tool.withdrawal') }}</th>
                  <th class="toolTable__cell">{{ _translate('tool.remainingBalance') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr class="toolTable__row" v-for="(item, index) in getRegularWithdrawalsTableData()">
                  <td class="toolTable__cell">{{item.year}}</td>
                  <td class="toolTable__cell">{{formatCurrency(item.withdrawal)}}</td>
                  <td class="toolTable__cell" v-html="formatCurrency(item.balance)"></td>
                </tr>
              </tbody>
            </table>             
          </div>
          <form v-if="isCurrentTool('regularWithdrawals')" class="tool__form">

            <div class="tool__form-wrap">
              <TextInput :label="_translate('tool.initialValue')" type="currency" field="tools.regularWithdrawals.sum"></TextInput>
              <TextInput :label="_translate('tool.atRateOf')" type="percentage" field="tools.regularWithdrawals.rate"></TextInput>
              <TextInput :label="_translate('tool.numberOfYears')" type="number" field="tools.regularWithdrawals.years"></TextInput>
              <Dropdown :label="_translate('tool.withdrawing')" proto="contributionFrequency" field="tools.regularWithdrawals.withdrawing"></Dropdown>
              <TextInput :label="_translate('tool.indexAt')" type="percentage" field="tools.regularWithdrawals.index"></TextInput>
              <div class="checkbox-wrap"><input id="showRegularWithdrawals" type="checkbox" class="checkbox__input" :checked="showTableChecked('regularWithdrawals')" @change="showTableUpdate('regularWithdrawals')"> <label for="showRegularWithdrawals" class="label">{{ _translate('tool.showSummaryTable') }}</label></div>

            </div>

          </form>          
        </div>

        <div v-if="setSystematicWithdrawals()" :class="getToolClass('systematicWithdrawals')">                             
          <div v-if="isCurrentTool('systematicWithdrawals')" class="tool__output">
<!--             <div class="tool__output-line">
              <span class="tool__output-label"><span v-html="getSavingsFutureFrequency()"></span> Investment Required:</span>
              <span class="tool__output-value" v-html="getSavingsFutureContribution()"></span>
            </div> -->
            <Chart type="bar" :data="getSystematicWithdrawalsData()" id="toolSystematicWithdrawalsChart" width="650" height="350"></Chart> 
             <p class="note" v-if="showTable('systematicWithdrawals')">{{ _translate('tool.systematicWithdrawlsFootnote') }}</p>
            <table v-if="showTable('systematicWithdrawals')" class="toolTable">
              <thead>
                <tr class="toolTable__row" >
                  <th class="toolTable__cell">{{ _translate('tool.period') }}</th>
                  <th class="toolTable__cell">{{ _translate('tool.withdrawal') }}</th>
                  <th class="toolTable__cell">{{ _translate('tool.gain') }}*</th>
                  <th class="toolTable__cell">{{ _translate('tool.balance') }}*</th>
                </tr>
              </thead>
              <tbody>
                <tr class="toolTable__row" v-for="(item, index) in getSystematicWithdrawalsTableData()">
                  <td class="toolTable__cell">{{item.period}}</td>
                  <td class="toolTable__cell">{{formatCurrency(item.withdrawal)}}</td>
                  <td class="toolTable__cell" v-html="formatCurrency(item.gain)"></td>
                  <td class="toolTable__cell" v-html="formatCurrency(item.balance)"></td>
                </tr>
              </tbody>
            </table>
          </div>
          <form v-if="isCurrentTool('systematicWithdrawals')" class="tool__form">

            <div class="tool__form-wrap">
              <TextInput :label="_translate('tool.initialValue')" type="currency" field="tools.systematicWithdrawals.sum"></TextInput>
              <TextInput :label="_translate('tool.withdrawalAmount')" type="currency" field="tools.systematicWithdrawals.withdrawal"></TextInput>
              <TextInput :label="_translate('tool.atRateOf')" type="percentage" field="tools.systematicWithdrawals.rate"></TextInput>
              <TextInput :label="_translate('tool.numberOfYears')" type="number" field="tools.systematicWithdrawals.years"></TextInput>
              <Dropdown :label="_translate('tool.withdrawing')" proto="contributionFrequency" field="tools.systematicWithdrawals.withdrawing"></Dropdown>
              <div class="checkbox-wrap"><input id="showSystematicWithdrawals" type="checkbox" class="checkbox__input" :checked="showTableChecked('systematicWithdrawals')" @change="showTableUpdate('systematicWithdrawals')"> <label for="showSystematicWithdrawals" class="label">{{ _translate('tool.showSummaryTable') }}</label></div>
            </div>

          </form>           
        </div>                

      </div>

  </form>

</template>

<script>

import Chart from './Chart.vue';
import TextInput from './TextInput.vue';
import Dropdown  from './Dropdown.vue';
import Icon from './Icon.vue';
 
export default {


	components: {

		TextInput,
    Dropdown,
    Chart,
    Icon,

	}, 

  /**
   * METHODS
   * -------
   * 
   * These are the methods that are available to the 
   * component.
   */
   
  methods : { 

    formatCurrency(val) {

      return window.formatCurrency(val);

    },

    isCurrentTool(context) {

      return context === this.$parent.$data.subpanel.context;

    },   

    setFormIcon() {

      var vars = this.$parent.getSubpanelData();
      
      return vars.icon;

    },  

    getToolClass(context) {

      var c = 'tool';

      if ( this.$parent.$data.subpanel.context === context ) {

        c += ' tool--active';

      }

      return c;

    },

    setField(field) {

      return this.$parent.$data.subpanel.field + '.' + field;

    },

    setFieldValue(field) {

      return this.$store.getters.getFieldData({ field: this.$parent.$data.subpanel.field + '.' + field });

    },

    getRawToolData(field) {

      return this.$store.getters.getFieldData({ field: field });

    },

    showTable(tool) {

      return this.$data.showTables[tool];

    },

    showTableChecked(tool) {

      if ( this.$data.showTables[tool] ) {

        return 'checked';

      }

      return false;

    },

    showTableUpdate(tool) {

      this.$data.showTables[tool] = ! this.$data.showTables[tool];

    },


    /**
     * SAVINGS FOR FUTURE
     *
     * The following functions are for the Savings for Future tool
     */
    setSavingsFutureData() {

      // if ( ! this.checkContext('savingsFuture') ) {

      //   return false;

      // }

      var data  = {},
          chartData = {
            contributions: {
              data: [],
              label: 'tool.chartContribution',
              color: 0,              
            },
            value: {
              data: [],
              label: 'tool.chartValue',
              color: 1,              
            },
            labels: [],
            otherData: {
              total: [],
              gain: [],
            }
          },
          sum   = Number(this.getRawToolData('tools.savingsFuture.sum')),
          rate  = Number(this.getRawToolData('tools.savingsFuture.rate')),
          years = Number(this.getRawToolData('tools.savingsFuture.years')),
          frequency = this.getRawToolData('tools.savingsFuture.depositing'),
          contribute = (frequency === '') ? 10 : 1,
          augment = (frequency === '') ? 10 : 1,
          total = 0;

      while ( total < sum ) {

        var value,
            total_contribution = 0,
            total_value = 0,
            gain = 0,
            total = 0;

        for ( var x = 0; x <= years; x++ ) {

          var c = contribute;

          if ( frequency === 'monthly' ) {

            c *= 12;

          }

          else if ( frequency === 'bi-weekly' ) {

            c *= 26;

          }

          value = ( x > 0 ) ? total * (1 + rate) + c : contribute;
          gain = value - total_contribution;
          total_contribution += c;

          data[x] = {

            value: value,
            contribute: c,
            label: x,
            gain: gain,
            total: total_contribution,

          };

          total = data[x].value;

        }

        if ( total < sum ) {

          contribute += augment;

        }

      }

      for ( var x in data ) {

        var y = Number(x);
        if ( y !== 0 ) {
          chartData.contributions.data[y - 1] = data[y].contribute;
          chartData.value.data[y - 1] = data[y].value;
          chartData.labels[y - 1] = data[y].label;

          chartData.otherData.total[y - 1] = data[y - 1].total;
          chartData.otherData.gain[y - 1] = data[y].gain;

        }

      }

      window.tables.toolSavingsFuture = {
        contribute: contribute,
        data: data,
        chartData: chartData,
      };

      return true;

    },

    getSavingsFutureContribution() {

      return window.formatCurrency(window.tables.toolSavingsFuture.contribute);

    },

    getSavingsFutureData() {

      return window.tables.toolSavingsFuture.chartData;

    },

    getSavingsFutureTableData() {

      var rawData = window.tables.toolSavingsFuture.chartData,
          data = [];

      for ( var x = 0; x < rawData.labels.length; x ++ ) {

        data[x] = {
          year: rawData.labels[x],
          contribution: rawData.contributions.data[x],
          gain: rawData.otherData.gain[x],
          total: rawData.otherData.total[x],
          value: rawData.value.data[x],
        }

      }

      return data;

    },


    getSavingsFutureFrequencyLabel() {

      var frequency = this.getSavingsFutureFrequency(),
          lang = this.$store.getters.getCurrentLanguage,
          label = '';

      if ( lang === 'fr' ) {
        return  this._translate('tool.monthlyInvestment') + ' ' + frequency + ' :';
      } else {
        return  frequency + ' ' + this._translate('tool.monthlyInvestment') + ':';
      }

    },

    getSavingsFutureFrequency() {

      var vars = this.$store.getters.getDropdownData({ field: 'tools.savingsFuture.depositing', proto: 'contributionFrequency' });
      return vars;

    },     




    setInvestmentFuture() {

      // if ( ! this.checkContext('investmentFuture') ) {

      //   return false;

      // }

      var data  = {},
          chartData = {
            contributions: {
              data: [],
              label: 'tool.chartTotalContribution',
              color: 0,              
            },
            value: {
              data: [],
              label: 'tool.chartFutureValue',
              color: 1,              
            },
            labels: [],
            otherData: {
              gain: [],
              contribute: [],
            }            
          },
          sum   = Number(this.getRawToolData('tools.investmentFuture.sum')),
          rate  = Number(this.getRawToolData('tools.investmentFuture.rate')),
          years = Number(this.getRawToolData('tools.investmentFuture.years')),
          frequency = this.getRawToolData('tools.investmentFuture.depositing'),
          contribute = this.getRawToolData('tools.investmentFuture.contribution'),
          augment = (frequency === '') ? 10 : 1,
          total = sum;

      for ( var x = 0; x < years; x++ ) {

        var value,
            gain = 0,
            total_contribution = 0,
            c = contribute;

        if ( frequency === 'monthly' ) {

          c *= 12;

        }

        else if ( frequency === 'bi-weekly' ) {

          c *= 26;

        }

        else if ( frequency === 'semi-monthly' ) {

          c *= 24;

        }

        else if ( frequency === 'weekly' ) {

          c *= 52;

        }        

        value = ( x > 0 ) ? total * (1 + rate) + c : (total + c) * (1 + rate);
        total_contribution = ( x > 0 ) ? data[x - 1].total + c : total + c;
        gain = value - total_contribution;


        data[x] = {

          value: value,
          total: total_contribution,
          label: x + 1,
          gain: gain,
          contribute: c,

        };

        total = data[x].value;

      }

      if ( total < sum ) {

        contribute += augment;

      }

      for ( var x in data ) {

        chartData.contributions.data[x] = data[x].total;
        chartData.value.data[x] = data[x].value;
        chartData.labels[x] = data[x].label;

        chartData.otherData.gain[x] = data[x].gain;
        chartData.otherData.contribute[x] = data[x].contribute;       

      }

      window.tables.toolInvestmentFuture = {
        data: data,
        chartData: chartData,
        futureValue: total,
      };

      return true;
      
    },

    getInvestmentFutureData() {

      return window.tables.toolInvestmentFuture.chartData;

    },

    getInvestmentFutureTableData() {

      var rawData = window.tables.toolInvestmentFuture.chartData,
          data = [];

      for ( var x = 0; x < rawData.labels.length; x ++ ) {

        data[x] = {
          year: rawData.labels[x],
          contribute: rawData.otherData.contribute[x],
          contribution: rawData.contributions.data[x],
          value: rawData.value.data[x],
          gain: rawData.otherData.gain[x],
        }

      }

      return data;

    },     

    getInvestmentFutureValue() {

      return window.formatCurrency(window.tables.toolInvestmentFuture.futureValue);

    },




    setRegularWithdrawals() {

      // if ( ! this.checkContext('regularWithdrawals') ) {

      //   return false;

      // }

      var data  = {},
          period_data = {},
          chartData = {
            withdrawals: {
              data: [],
              label: 'tool.chartWithdrawal',
              color: 0,
            },
            balance: {
              data: [],
              label: 'tool.chartBalance',
              color: 1,
            },
            labels: [],
          },
          sum   = Number(this.getRawToolData('tools.regularWithdrawals.sum')),
          rate  = Number(this.getRawToolData('tools.regularWithdrawals.rate')),
          years = Number(this.getRawToolData('tools.regularWithdrawals.years')),
          index = Number(this.getRawToolData('tools.regularWithdrawals.index')),
          frequency = this.getRawToolData('tools.regularWithdrawals.withdrawing'),
          withdrawal = (frequency === '') ? 10 : 1,
          augment = (frequency === '') ? 1 : 1,
          total = sum,
          factor = (index > 0) ? (1 + index) : 1,

          p = 1,
          i = 1;

      if ( frequency === 'monthly' ) {

        p = 12;

      }

      else if ( frequency === 'bi-weekly' ) {

        p = 26;

      }   

      else if ( frequency === 'semi-monthly' ) {

        p = 24;

      }   

      else if ( frequency === 'weekly' ) {

        p = 52;

      }               

      while ( total > 0 ) {

        total = sum;

        if ( total > 1000000000 ) {

          augment = 1000;

        }

        else if ( total > 1000000 ) {

          augment = 100;

        }

        else if ( total > 10000000 ) {

          augment = 10;

        }

        else {

          augment = 1;

        }

        var _w = withdrawal;     

        // i = 0;

        for ( var x = 0; x < years + 1; x++ ) {

          // i += 1;

          var w = withdrawal;

          if ( total < 5000 ) {

            augment = .01;

          }

          else if ( total < 10000 ) {

            augment = .1;

          }

          data[x] = {

            balance: ( x > 0 ) ? total * (1 + rate) - w : total - w,
            withdrawal: w,
            label: x,
            w: withdrawal,
            a: augment,

          };

          total = data[x].balance;
          withdrawal *= factor;

        }

        if ( total > 0 ) {

          withdrawal = _w;
          withdrawal += augment;

        }

      }

      delete data[x - 1];

      var y = 0;
      for ( var x in data ) {

        var b = data[x].balance;
        var w = data[x].withdrawal / p;

        var interest = (b * rate) / p;

        for ( var i = 0; i < p; i++ ) {

          period_data[y] = {

            balance: b,
            withdrawal: w,
            label: y + 1,
            interest: interest,

          }

          // if ( i === 0 && y > 0 ) {

          //   period_data[y].interest = window.formatCurrency(period_data[y].balance - period_data[y - 1].balance);
            
          // }          

          b -= (w - interest);
          y += 1;

        }

      }

      for ( var x in data ) {

        var y = Number(x);
          chartData.withdrawals.data[y] = data[y].withdrawal;
          chartData.balance.data[y] = (data[y].balance > 0) ? data[y].balance : 0;
          chartData.labels[y] = Number(data[y].label) + 1;

      }

      window.tables.toolRegularWithdrawals = {
        withdrawal: period_data[0].withdrawal,
        data: period_data,
        chartData: chartData,
      };

      return true;


    },

    getRegularWithdrawalsData() {

      return window.tables.toolRegularWithdrawals.chartData;

    },


    getRegularWithdrawalsTableData() {

      var rawData = window.tables.toolRegularWithdrawals.data,
          data = [];

      for ( var x in rawData ) {

        data[x] = {
          year: rawData[x].label,
          balance: rawData[x].balance,
          withdrawal: rawData[x].withdrawal,
          interest: rawData[x].interest,
        }

      }

      return data;

    },    

    getRegularWithdrawalsWithdrawal() {

      return window.formatCurrency(window.tables.toolRegularWithdrawals.withdrawal);

    }, 

    getRegularWithdrawalsFrequencyLabel() {

      var frequency = this.getRegularWithdrawalsFrequency(),
          lang = this.$store.getters.getCurrentLanguage,
          label = '';

      var string = this._translate('tool.regularWithdrawals');

      return string.replace('%s', frequency);

    },

    getRegularWithdrawalsFrequency() {

      var vars = this.$store.getters.getDropdownData({ field: 'tools.regularWithdrawals.withdrawing', proto: 'contributionFrequency' });
      return vars;

    },



    setSystematicWithdrawals() {

      var data  = {},
          period_data = {},
          chartData = {
            withdrawals: {
              data: [],
              label: 'tool.chartWithdrawal',
              color: 0,
            },
            balance: {
              data: [],
              label: 'tool.chartBalance',
              color: 1,
            },
            labels: [],
          },
          sum        = Number(this.getRawToolData('tools.systematicWithdrawals.sum')),
          withdrawal = Number(this.getRawToolData('tools.systematicWithdrawals.withdrawal')),
          rate       = Number(this.getRawToolData('tools.systematicWithdrawals.rate')),
          years      = Number(this.getRawToolData('tools.systematicWithdrawals.years')),
          index      = Number(this.getRawToolData('tools.systematicWithdrawals.index')),
          frequency  = this.getRawToolData('tools.systematicWithdrawals.withdrawing'),
          total      = sum,
          gained     = 0,
          p          = 1,
          b          = total,
          w          = 0;

      if ( frequency === 'monthly' ) {

        p = 12;

      }

      else if ( frequency === 'bi-weekly' ) {

        p = 26;

      }   

      else if ( frequency === 'semi-monthly' ) {

        p = 24;

      }

      else if ( frequency === 'weekly' ) {

        p = 52;

      }      

      for ( var x = 0; x < years; x++ ) {

        w = 0;
        b = total;
        for ( var y = 0; y < p; y++ ) {

          total -= withdrawal;
          w     += withdrawal

        }

        if ( total <= 0 ) {

          w += total;

          gained = 0;
          total = 0;



        }

        else {

          gained = total * rate;
          total *= 1 + rate;

        }

        data[x] = {
            starting: b,
            balance: total,
            withdrawal: w,
            label: x + 1,
            gain: gained,
        }

      }

      var y = 0;
      for ( var x in data ) {

        var b = data[x].starting;
        var w = data[x].withdrawal / p;

        var interest = data[x].gain / p;

        for ( var i = 0; i < p; i++ ) {

          b -= (w - interest);

          period_data[y] = {

            balance: b,
            withdrawal: w,
            label: y + 1,
            gain: interest,

          }         

          y += 1;

        }

      }

      for ( var x in data ) {

        var y = Number(x);
          chartData.withdrawals.data[y] = data[y].withdrawal;
          chartData.balance.data[y] = (data[y].balance > 0) ? data[y].balance : 0;
          chartData.labels[y] = Number(data[y].label) + 1;

      }

      window.tables.toolSystematicWithdrawals = {
        withdrawal: withdrawal,
        data: period_data,
        chartData: chartData,
      };

      return true;

    },

    getSystematicWithdrawalsData() {

      return window.tables.toolSystematicWithdrawals.chartData;

    },


    getSystematicWithdrawalsTableData() {

      var rawData = window.tables.toolSystematicWithdrawals.data,
          data = [];


      for ( var x in rawData ) {

        data[x] = {
          period: rawData[x].label,
          balance: rawData[x].balance,
          withdrawal: rawData[x].withdrawal,
          gain: rawData[x].gain,
        }

      }

      return data;

    },    

    getSystematicWithdrawalsWithdrawal() {

      return window.formatCurrency(window.tables.toolSystematicWithdrawals.withdrawal);

    }, 

    getSystematicWithdrawalsFrequency() {

      var vars = this.$store.getters.getDropdownData({ field: 'tools.regularWithdrawals.withdrawing', proto: 'contributionFrequency' });
      return vars;

    }

  },


  /**
   * COMPUTED
   * --------
   * 
   * These functions are used to return computed values, which
   * can be bound to certain portions of the component.
   */  

  computed: {

    setFormTitle() {

      var vars = this.$parent.getSubpanelData();
      return vars.title;

    },

  },

  props : [
  	
    'field',

  ],

  data() {

    return {

      showTables: {

        savingsRequired: false,
        futureValue: false,
        regularWithdrawals: false,
        systematicWithdrawals: false,

      }

    }

  }

}

</script>

<style lang="scss">

  .tool-panel__block {

    padding: 2.5rem;
    color: #000;

    h2 {

      padding: 0;

      .icon {

        display: inline-block;
        width: 2rem;
        height: 2rem;
        margin-right: 1rem;

        transform: translate3d(0, -.125em, 0);

      }

      .icon__svg {

        fill: #999;
        stroke: #999;

      }

    }

  }

  .tool {

    display: flex;
    max-height: 0;
    // overflow: hidden;

    .chart {

      width: calc(100% + 2rem);
      padding: 1rem;
      margin-left: -1rem;
      margin-right: -1rem;
      margin-bottom: 1rem;

    }

  }

  .tool--active {

    margin-top: 1.5rem;
    padding-bottom: 4rem;
    max-height: none;

  }

  .tool__form {

    width: 19rem;
    margin-left: 3rem;
    background: #f4f4f4;
    padding: 1.5rem;

    .dropdown__list {

      color: #fff;

    }

    .input {

      box-shadow: none;

    }

    .checkbox-wrap {

      label {

        display: inline-block;
        transform: translate3d(0, -.1rem, 0);

      }

    }

  }

  .tool__output {

    width: calc(100% - 22rem);

    .note {

      margin: 2em 0 1em;

    }    

  }

  .tool__output-line {

    margin-bottom: 2rem;

  }

  .tool__output-value {

    color: #06a0df;

  }

  .toolTable {

    width: 100%;

  }

  .toolTable__row {

    border-bottom: 1px solid #eee;

  }

  .toolTable__cell {

    font-size: .8rem;
    text-align: left;
    padding: .75rem;

  }

</style>


// WEBPACK FOOTER //
// ToolPanel.vue?d5863d88